// @flow

import _ from 'lodash/fp';
import React from 'react';
import classNames from 'classnames';
import NumberFormat from 'react-number-format';

export type Props = {
  disabled?: boolean,
  input: any,
  label: string,
  meta: any,
  onChangeTransform?: Function,
  valueTransform?: Function,
};

const DecimalFormInput = ({input, label, meta: {touched, error}, onChangeTransform, valueTransform, disabled}: Props) => (
  <div>
    <label className={classNames({'is-invalid-label': touched && error})}>
      {label}
    </label>
    <div>
      <NumberFormat
        value={
          !input.value
            ? input.value
            : valueTransform
              ? valueTransform(input.value)
              : input.value
        }
        onValueChange={(val, evt) => {
          input.onChange(_.isEmpty(val.value)
            ? null
            : onChangeTransform
              ? onChangeTransform(val.floatValue)
              : val.floatValue);
        }}
        disabled={!!disabled}
        onBlur={() => input.onBlur(input.value)}
        decimalSeparator={','}
        decimalScale={5}
        placeholder={label}
        className={classNames({'is-invalid-input': touched && error})} />
      {touched && error &&
        <span className="form-error is-visible">{error}</span>
      }
    </div>
  </div>
);

export default DecimalFormInput;



// WEBPACK FOOTER //
// ./src/components/DecimalFormInput/DecimalFormInput.js